<template>
  <el-card >
    <!-- 查询表单 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="教学楼:">
        <el-select style="width:180px"  v-model="searchFactor.buildingId">
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            v-for="(item , index) in buildingList"
            :key="index"
            :label="item.buildingName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="楼层:">
        <el-select style="width:80px" v-model="searchFactor.floor">
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            v-for="(item , index) in 14"
            :key="index"
            :label="(item - 4).toString()"
            :value="(item - 4).toString() ">
          </el-option>
        </el-select>
        </el-form-item> -->
      <el-form-item   label="实验室:">
        <el-input  style="width: 150px" v-model="searchFactor.storeroomName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="安全等级:">
        <el-select style="width:100px"  v-model="searchFactor.safeGradeId">
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            v-for="(item , index) in safeGradeList"
            :key="index"
            :label="item.safeGrade"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="团队:">
        <el-select style="width:100%" :disabled  = "searchFactor.triggerGetUser"  @change="searchDeptIdChange" v-model="searchFactor.deptId">
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            v-for="(item,index) in deptList"
            :key="index"
            :label="item.deptName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="安全责任人:">
        <el-select style="width:150px" v-model="searchFactor.safeUserId">
          <el-option
            label="全部"
            value="">
          </el-option>
          <el-option
            v-for="(item, index) in searchFactor.userList"
            :key="index"
            :label="item.fullName+ '(' +  item.usrName + ')'"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateSafeManage">创建</el-button>
      </el-form-item>
    </el-form>
    <!-- 角色表格 -->
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="buildingName"
        label="教学楼"
        min-width="80px">
      </el-table-column>
      <!-- <el-table-column
        prop="floor"
        min-width="30px"
        label="楼层" >
      </el-table-column> -->
      <el-table-column
        prop="storeroomName"
        min-width="60px"
        label="实验室" >
      </el-table-column>
      <el-table-column
        prop="safeGrade"
        min-width="60px"
        label="安全等级" >
      </el-table-column>
      <el-table-column
        prop="deptName"
        min-width="100px"
        label="团队" >
      </el-table-column>
      <el-table-column
        prop="fullName"
        :formatter="formatSafeUser"
        min-width="50px"
        label="安全责任人" >
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="100px">
      </el-table-column>
      <el-table-column label="操作" min-width="120px" >
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"delete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除实验室</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"edit",index:scope.$index, data:scope.row}'><i class="el-icon-document" style="color:rgb(40, 238, 10)" ></i> <span>修改实验室</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleViewStoreroom",index:scope.$index, data:scope.row}'><i class="el-icon-search" style="color:rgb(39, 193, 231)"></i> <span>预览</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
     <!-- 分页组件 -->
    <el-pagination
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount" style="margin:10px">
    </el-pagination>
    
    <!-- 创建实验室施弹框 -->
    <el-dialog :close-on-click-modal= "false" :visible.sync="dialogVisual.createStoreroomDialogVisible" v-on:close ="clearCreateStoreroomInfoForm" >
      <div slot="title" class="dialog-footer">
        <span> 创建实验室 </span>
      </div>
      <el-form :model="createStoreroomForm" label-width="30%"> 
        <el-row>
        <el-col :span="12">
          <el-form-item label="教学楼:">
            <el-select style="width:100%" v-model="createStoreroomForm.buildingId">
              <el-option
                v-for="(item , index) in buildingList"
                :key="index"
                :label="item.buildingName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="楼层:">
            <el-select style="width:100%" v-model="createStoreroomForm.floor">
              <el-option
                v-for="(item , index) in 14"
                :key="index"
                :label="(item - 4).toString()"
                :value="(item - 4).toString()">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item  style="width: 100%" label="实验室:">
            <el-input  v-model="createStoreroomForm.storeroomName" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="安全等级:">
            <el-select style="width:100%"  v-model="createStoreroomForm.safeGradeId">
              <el-option
                v-for="(item , index) in safeGradeList"
                :key="index"
                :label="item.safeGrade"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="团队:">
            <el-select style="width:100%" :disabled  = "createStoreroomForm.triggerGetUser"  @change="deptIdChange" v-model="createStoreroomForm.deptId">
              <el-option
                v-for="(item , index) in deptList"
                :key="index"
                :label="item.deptName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="安全责任人:">
            <el-select style="width:100%" v-model="createStoreroomForm.safeUserId">
              <el-option
                v-for="(item , index) in createStoreroomForm.userList"
                :key="index"
                :label="item.fullName+ '(' +  item.usrName + ')'"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
        <el-row>

          <el-col :span="24">
          <el-form-item  label-width="15%" label="安全措施:">
            <el-select style="width:100%" collapse-tags  multiple  v-model="createStoreroomForm.safeManageOptionSet">
              <el-option
                v-for="(item , index) in safeMangeList"
                :key="index"
                :label="'(' + (index + 1 )  + ') ' + item.safeManageOption"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="简介:" label-width="15%" style="width: 100%">
              <el-input type="textarea" v-model="createStoreroomForm.detail" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建实验室</el-button>
      </div>
    </el-dialog>

    <!-- 修改实验室施弹框 -->
    <el-dialog :close-on-click-modal= "false" :visible.sync="dialogVisual.editStoreroomDialogVisible" v-on:close ="clearCreateStoreroomInfoForm" >
      <div slot="title" class="dialog-footer">
        <span> 修改实验室信息 </span>
      </div>
      <el-form :model="editStoreroomForm" label-width="30%"> 
        <el-row>
        <el-col :span="12">
          <el-form-item label="教学楼:">
            <el-select style="width:100%" v-model="editStoreroomForm.buildingId">
              <el-option
                v-for="(item , index) in buildingList"
                :key="index"
                :label="item.buildingName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="楼层:">
            <el-select style="width:100%" v-model="editStoreroomForm.floor">
              <el-option
                v-for="(item , index) in 14"
                :key="index"
                :label="item - 4"
                :value="item - 4">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item  style="width: 100%" label="实验室:">
            <el-input  v-model="editStoreroomForm.storeroomName" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="安全等级:">
            <el-select style="width:100%"  v-model="editStoreroomForm.safeGradeId">
              <el-option
                v-for="(item , index) in safeGradeList"
                :key="index"
                :label="item.safeGrade"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="团队:">
            <el-select style="width:100%" :disabled  = "editStoreroomForm.triggerGetUser"  @change="deptIdEditChange" v-model="editStoreroomForm.deptId">
              <el-option
                v-for="(item , index) in deptList"
                :key="index"
                :label="item.deptName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="安全责任人:">
            <el-select style="width:100%" v-model="editStoreroomForm.safeUserId">
              <el-option
                v-for="(item , index) in editStoreroomForm.userList"
                :key="index"
                :label="item.fullName+ '(' +  item.usrName + ')'"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item  label-width="15%" label="安全措施:">
            <el-select style="width:100%" collapse-tags  multiple  v-model="editStoreroomForm.safeManageOptionSet">
              <el-option
                v-for="(item , index) in safeMangeList"
                :key="index"
                :label="'(' + (index + 1 )  + ') ' + item.safeManageOption"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="简介:" label-width="15%" style="width: 100%">
            <el-input type="textarea" v-model="editStoreroomForm.detail" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureEdit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 预览一个试题 -->
    <el-dialog :visible.sync="dialogVisual.viewStoreroomDialogVisible" v-on:close ="clearViewQbForm" >
      <el-card class="box-card">
          <div slot="header"  style="height: 20px;margin: 0;" class="clearfix">
            <el-tag>{{ viewStoreroomForm.buildingName }}</el-tag>
            <el-tag type="warning">{{ viewStoreroomForm.storeroomName }}</el-tag>
            <!-- <el-tag type="warning">{{ viewStoreroomForm.floor +'楼' }}</el-tag> -->
            <el-tag type="success">{{  viewStoreroomForm.deptName }}</el-tag>
          </div>
          <div style ="margin-top: 1px;" >
            <el-tag type="warning" style="width: 80px;text-align: left;">安全等级{{viewStoreroomForm.safeGrade + '级'}}</el-tag>
            <span style ="margin-left: 10px; ">{{ viewStoreroomForm.safeGradeRemark }}</span>
          </div>
          <div style ="margin-top: 5px;display: flex;">
            <div>
              <el-image  v-if = "viewStoreroomForm.headImage != null && viewStoreroomForm.headImage!= ''"
              style="width: 80px; height: 80px ; border-radius: 1px;"
              :src="viewStoreroomForm.headImage"
              :fit="'fit'"></el-image>
              <!-- <el-image  :fit="'fit'" v-else>
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline " style="width: 80px; height: 80px ; "></i>
                </div>
              </el-image> -->
            <el-avatar v-else  style="display: flex; background-color: rgb(47, 47, 228); height:80px;width: 80px; align-items: center; justify-content: space-around; "> {{ viewStoreroomForm.fullName  }} </el-avatar>
            </div>
            <div style="margin-left: 10px">
              <div>  
                  姓名: {{viewStoreroomForm.fullName }}({{viewStoreroomForm.userName }})
              </div>
              <div>  
                  性别: {{viewStoreroomForm.gender == 0? '女':'男' }}
              </div>
              <div>  
                  电话: {{viewStoreroomForm.phoneNo }}
              </div>
              <div>  
                  邮箱: {{viewStoreroomForm.email }}
              </div>
            </div>
          </div>
          <div style ="margin-top: 5px; overflow: auto;" >
            <el-tag type="warning" style ="width:80px">安全措施+{{ viewStoreroomForm.safeManageList == null ? 0 :viewStoreroomForm.safeManageList.length }}</el-tag>
            <span v-for="(item,index) in viewStoreroomForm.safeManageList" :key="index" style ="margin-left: 10px;">
              {{ (index + 1)+"."+ item.safeManageOption }}
            </span>
          </div>
          <div style ="margin-top: 10px;" >
            <el-tag type="warning" >实验室说明</el-tag>
            <span style ="margin-left: 10px;">{{viewStoreroomForm.detail }}</span>
          </div>
        </el-card>
    </el-dialog>
  </el-card>
</template>                     
<script>
import axios from  '@/api/axiosConfig'
import {stringIsNullOrEmpty} from  '@/api/utils'
import {MESSAGE_DURATION,PAGE_SIZE} from  '@/api/constant'
export default {
    name : 'pc_ctr_storeroom',
    data() {
    return {
      searchFactor:{
        storeroomName: '',
        detail: '',
        floor : '',
        buildingId :'',
        safeGradeId:'',
        deptId:'',
        safeUserId: '',
        triggerGetUser : false,
        userList : []
      },
      tableData: [],
      buildingList:[],
      deptList:[],
      safeGradeList:[],
      safeMangeList:[],
      dialogVisual:{
        editStoreroomDialogVisible: false,
        createStoreroomDialogVisible: false,
        viewStoreroomDialogVisible: false,
      },
      createStoreroomForm: {
        storeroomName: '',
        detail: '',
        floor : '',
        buildingId :'',
        safeGradeId:'',
        deptId:'',
        safeUserId: '',
        safeManageOptionSet :[],
        userList :[],
        triggerGetUser : false
      },
      editStoreroomForm: {
        storeroomName: '',
        detail: '',
        floor : '',
        buildingId :'',
        safeGradeId:'',
        deptId:'',
        safeUserId: '',
        safeManageOptionSet :[],
        userList :[],
        triggerGetUser : false
      },
      viewStoreroomForm:{
      },
      pager:{
        totalCount:0,
        pageSize : PAGE_SIZE
      }
  }
  },
  methods : {
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'delete' :
          this.handleDelete(index,row)
          break
        case 'edit' :
          this.handleEdit(index,row)
          break
        case 'handleViewStoreroom':
          this.handleViewStoreroom(index,row)
          break
      }
    },

    formatSafeUser(row, index){
       return row.userName + '(' + row.fullName +')'
    },
    indexMethod(index){
      return  index + 1
    },

    handleViewStoreroom(index,row){
      this.dialogVisual.viewStoreroomDialogVisible = true
      this.viewStoreroomForm = {...row}
    },

    clearViewQbForm(){
      this.dialogVisual.viewStoreroomDialogVisible = false  
    },

    deptIdEditChange(id){
      if(this.editStoreroomForm.triggerGetUser ) {
        return 
      }
      this.editStoreroomForm.triggerGetUser = true 
      this.editStoreroomForm.userList.splice(0)
      this.editStoreroomForm.safeUserId = ''
      this.doDeptIdChange(id, this.editStoreroomForm)
    },

    deptIdChange(id){
      if(this.createStoreroomForm.triggerGetUser ) {
        return 
      }
      this.createStoreroomForm.triggerGetUser = true 
      this.createStoreroomForm.userList.splice(0)
      this.createStoreroomForm.safeUserId = ''
      this.doDeptIdChange(id, this.createStoreroomForm)
    },
    searchDeptIdChange(id){
      if(id == ''){
        this.searchFactor.userList.splice(0)
        return 
      }
      if(this.searchFactor.triggerGetUser ) {
        return 
      }
      this.searchFactor.triggerGetUser = true 
      this.searchFactor.userList.splice(0)
      this.searchFactor.safeUserId = ''
      this.doDeptIdChange(id,this.searchFactor)
    },
    async doDeptIdChange(id , obj ){
      let url = "/bc/exa/usr/usrDeptPage"
      let dat0 = {
        pageSize: 100,
        deptId : id,
        pageNo : 1
      }
      axios.post(url, dat0).then((response) => {
        obj.triggerGetUser = false
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            dat.data.forEach(t=>{
              obj.userList.push(t)
            })
          } else {
            this.$message({
              showClose: true,
              message: '未查询到用户信息信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err) => {
          obj.triggerGetUser = false
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
   
    clearEditStoreroomInfoForm(){
      this.editStoreroomForm.id = ''
      this.editStoreroomForm.safeUserId = ''
      this.editStoreroomForm.detail = ''
      this.editStoreroomForm.deptId = ''
      this.editStoreroomForm.buildingId = ''
      this.editStoreroomForm.floor = ''
      this.editStoreroomForm.safeGradeId = ''
      this.editStoreroomForm.safeManageOptionSet.splice(0)
      this.editStoreroomForm.storeroomName = ''
      this.editStoreroomForm.userList.splice(0)
    },
    clearCreateStoreroomInfoForm(){
      this.createStoreroomForm.safeUserId = ''
      this.createStoreroomForm.detail = ''
      this.createStoreroomForm.deptId = ''
      this.createStoreroomForm.buildingId = ''
      this.createStoreroomForm.floor = ''
      this.createStoreroomForm.safeGradeId = ''
      this.createStoreroomForm.safeManageOptionSet.splice(0)
      this.createStoreroomForm.storeroomName = ''
      this.createStoreroomForm.userList.splice(0)
    },
    onSearch(){
      this.storeroomListLoad(1)
    },
    async handleEdit(index, row){
      await  this.doDeptIdChange(row.deptId,this.editStoreroomForm)
      this.dialogVisual.editStoreroomDialogVisible = true
      this.editStoreroomForm.id = row.id
      this.editStoreroomForm.safeUserId = row.safeUserId
      this.editStoreroomForm.safeGradeId = row.safeGradeId
      this.editStoreroomForm.detail = row.detail
      this.editStoreroomForm.deptId = row.deptId
      this.editStoreroomForm.buildingId = row.buildingId
      this.editStoreroomForm.floor = row.floor
      this.editStoreroomForm.safeManageOptionSet.splice(0)
      if(row.safeManageList != null &&row.safeManageList.length != 0 ){
        row.safeManageList.forEach(t=>{
          this.editStoreroomForm.safeManageOptionSet.push(t.id)
        })
      }

      this.editStoreroomForm.storeroomName = row.storeroomName
    },
    handleCreateSafeManage(){
      this.dialogVisual.createStoreroomDialogVisible = true
      this.createStoreroomForm.userList.splice(0)
    },
   
    ensureCreate(){
      try{ 
        stringIsNullOrEmpty(this.createStoreroomForm.buildingId ,'请输入实验室门所属教学楼!');
        stringIsNullOrEmpty(this.createStoreroomForm.storeroomName,'请输入实验室门牌号!');
        stringIsNullOrEmpty(this.createStoreroomForm.deptId,'请选择实验室所属团队!');
        stringIsNullOrEmpty(this.createStoreroomForm.safeUserId,'请选择实验室安全管理人员!');
        stringIsNullOrEmpty(this.createStoreroomForm.safeGradeId,'请选择实验室安全等级!');
        stringIsNullOrEmpty(this.createStoreroomForm.detail,'请输入实验室简介!');
        if(this.createStoreroomForm.safeManageOptionSet.length == 0){
            throw "请选择实验室安全管理措施!"
        }
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      this.doCreateStoreroomInfo()
    },

    ensureEdit(){
      try{ 
        stringIsNullOrEmpty(this.editStoreroomForm.buildingId ,'请输入实验室门所属教学楼!');
        stringIsNullOrEmpty(this.editStoreroomForm.storeroomName ,'请输入实验室门牌号!');
        stringIsNullOrEmpty(this.editStoreroomForm.deptId,'请选择实验室所属团队!');
        stringIsNullOrEmpty(this.editStoreroomForm.safeUserId,'请选择实验室安全管理人员!');
        stringIsNullOrEmpty(this.editStoreroomForm.safeGradeId,'请选择实验室安全等级!');
        stringIsNullOrEmpty(this.editStoreroomForm.detail,'请输入实验室简介!');
        if(this.editStoreroomForm.safeManageOptionSet.length == 0){
          throw "请选择实验室安全管理措施!"
        }
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      this.doEditStoreroomInfo()
    },
    doCreateStoreroomInfo(){
      let url = "/bc/exa/storeroom/addOne"
      let s = JSON.stringify(this.createStoreroomForm)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.clearCreateStoreroomInfoForm()
          this.$message({
            showClose: true,
            message: '创建成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{
            this.storeroomListLoad(1)
          },200)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }, 
    doEditStoreroomInfo(){
      let url = "/bc/exa/storeroom/editOne"
      let s = JSON.stringify(this.editStoreroomForm)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.editStoreroomDialogVisible = false
          this.clearEditStoreroomInfoForm()
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{
            this.storeroomListLoad(1)
          },200)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }, 
    handleDelete(index, row){
      this.$confirm('即将删除实验室['+row.storeroomName+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteStoreroom(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteStoreroom(row){
      let dat = {id: row.id}
      let url = "/bc/exa/storeroom/deleteOne"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{this.storeroomListLoad(1)},200)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
  
    handleCurrentChange(val){
      this.storeroomListLoad(val);
    },
    buildingListLoad(pageNo){
      let url = "/bc/exa/building/buildingPage"
      let dat0 = {
        pageSize: 100,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.buildingList = [];
            dat.data.forEach(t=>this.buildingList.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到教学楼信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    storeroomListLoad(pageNo){
      let url = "/bc/exa/storeroom/storeroomPage"
      let {
          storeroomName,deptId,safeGradeId,safeUserId,floor,buildingId
      } = this.searchFactor
      let dat =  {
        storeroomName,deptId,safeGradeId,safeUserId,floor,buildingId,
        pageNo, pageSize:PAGE_SIZE
      }

      axios.post(url, dat).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.data.length !== 0){
            this.tableData = []
            response.data.data.data.forEach(t=>{
              this.tableData.push(t)
            })
            this.pager.totalCount = response.data.data.totalDataCount;
          }else{
            this.$message({
              showClose: true,
              message: '未查询到实验室数据！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) =>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    safeManageListLoad(pageNo){
      let url = "/bc/exa/safeManage/safeManagePage"
      let dat0 = {
        pageSize: 100,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.safeMangeList = [];
            dat.data.forEach(t=>this.safeMangeList.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到安全等级信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    
    deptListLoad(){
      let url = "/bc/exa/dept/getDeptTree"
      let dat0 = { }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data;
          if(dat.data.length !== 0){
            this.deptList = [];
            response.data.data.forEach(t=>{
              if(t.level == 1){
                this.deptList.push({id: t.id,deptName: t.deptName })
              }
            })
          } else {
            this.$message({
              showClose: true,
              message: '未查询到团队！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    safeGradeListLoad(){
      let url = "/bc/exa/safeGrade/all"
      let dat0 = {  
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data
          if(dat.data.length !== 0){
            this.safeGradeList = [];
            dat.data.forEach(t=>this.safeGradeList.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到安全等级信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    // 查询用户列表
    onSearch(){
      this.storeroomListLoad(1)
    },
  },
  created () {
    setTimeout(()=>{this.deptListLoad()},200)
    setTimeout(()=>this.buildingListLoad(1),200)
    setTimeout(()=> this.safeGradeListLoad(),200)
    setTimeout(()=>this.safeManageListLoad(1),200)
    this.storeroomListLoad(1)
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

.text {
  font-size: 14px;
  color: #000;
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_storeroom.vue